import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFLookupInput } from "src/components/Shared/NewForms/NFLookupInput";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";

const CommodityWaybillsDetailMain = () => {
  const waybillStatusType = [
    { id: 0, name: "Active" },
    { id: 1, name: "Cancelled" },
    { id: 2, name: "Completed" },
    { id: 3, name: "SentToCarrier" },
    { id: 4, name: "Unknown" }
  ];
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFLookupInput title={"Waybill Type"} fieldName={"rsStatus"} items={waybillStatusType} />
        </Col>
        <Col sm={6}>
          <NFLookupInput title={"Category"} fieldName={"category"} items={waybillStatusType} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("WaybillNumber")} fieldName={"waybillNumber"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("NameOfTheTransporter")} fieldName="nameOfTheTransporter" />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput title={t("StartingPlaceOfTransportation(Address")} fieldName={"transportationStart"} />
        </Col>

        <Col sm={6}>
          <NFDateInput title={t("ActivationDate")} fieldName={"activationDate"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("IdentificationNumber")} fieldName="vehiclePlateNumber" />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("FullName")} fieldName="fullName" />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCompany title={t("Company")} fieldName={"companyId"} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("TransportationStartAddress")} fieldName={"transportationStartAddress"} />
        </Col>
      </Row>
    </>
  );
};

export default CommodityWaybillsDetailMain;
